/*eslint-disable */
<template>
  <div class="questionContainer">
    <div class="row">
      <div class="col-6 tags">
        <h3>{{ queData.app_name }}</h3>
      </div>
      <div class="col-6 duration">
        <div class="pull-right d-flex">
          <div class="counts mr-2">
            <select v-if="propQuestionBankObj.questionNumber" class="form-control mr-2 font-size-16 primary-color" disabled>
              <option>
                {{ propQuestionBankObj.questionNumber }}
              </option>
            </select>
          </div>
          <span id="timer" v-if="propQuestionBankObj.q_time_spent">
            <span class="clock_boxs" title="Time taken to answer this question"><span class="clock_box1">{{propQuestionBankObj.q_time_spent}}&nbsp;Sec</span></span>
          </span>
        </div>
      </div>
    </div>
    <div class="row questionRow m-0 w-100">
      <div class="col-sm-12 col-md-12 col-lg-6 que p-0">
        <div class="sidebarContainer m-2">
          <!-- title -->
          <span v-if="queData.question">
            <h5 class="mb-2">
              <small style="font-weight: 600;" class="">Question Id:&nbsp;<span class="primary-color id_responsive">{{queData.qbk_id}}</span></small>
              <span v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" @click="quizBankEdit(queData.qbk_id)" class="pull-right ml-2" title="Edit Question">
                <i class="fa fa-edit font-size-20 primary-color pointer" aria-hidden="true"></i>
              </span>
              <!-- images -->
              <span v-if="queData.image" @click="imgModal(queData.image)" class="magnifying_glass">
                <img class="que_img mb-2" :src="queData.image" style="width: 100%;"/>
              </span>
              <span v-if="queData.image" class="pull-right ml-2" title="Image Zoom">
                <i @click="imgModal(queData.image)" class="fa fa-search-plus primary-color font-size-20" aria-hidden="true"></i>
              </span>
              <span v-if="queData.question && queData?.question?.includes('<img src')" class="pull-right ml-2" title="Image Zoom">
                <i @click="imgModal(queData.question)" class="fa fa-search-plus primary-color font-size-20" aria-hidden="true"></i>
              </span>
              <span v-if="queData.has_calc" @click="showCalculatorModal= !showCalculatorModal" class="pull-right ml-2" title="Desmos Calculator">
                <i class="fa-solid fa-calculator font-size-20 primary-color" aria-hidden="true"></i>
              </span>
            </h5>
            <h5 class="mt-2"><span class="is-2 questionTag vhtmlUlLi questionTagP" v-html="queData.question"></span></h5>
          </span>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-6 que questionBox">
        <div class="questionContainer">
          <!-- quizOptions -->
          <div class="optionContainer" :key="update">
            <template v-if="queData.is_mcq == 1">
              <div
                class="option"
                v-for="(choice, optionNo) in queData.answer_choices"
                :class="{ 'is-selected': userResponses[queData.qbk_id] && userResponses[queData.qbk_id][optionNo],
                          'bg-gray': String(optionNo) === String(propQuestionBankObj?.user_response)  // highlight selected
                 }"
                :key="optionNo"
              >
                <span class="optionNo">
                  <span class="capitalize mr-2">
                    {{ optionNo}}
                  </span>
                </span>
                <span v-html="choice"></span>
              </div>
              <div class="questionFooter text-capitalize">
                <h5 >Correct Answer : <span class="success-color pill_badge_box bg_green" style="text-transform: capitalize;" > {{ queData.correct_answers }} </span> </h5>
                <h5>
                  Your Answer:
                  <span
                    v-if="propQuestionBankObj?.user_response === 'z'"
                    style="color: orange"
                  >
                    Unattempted
                  </span>
                  <span
                    v-else-if="propQuestionBankObj?.user_response?.trim().toLowerCase() === queData.correct_answers?.trim().toLowerCase()"
                    class="pill_badge_box bg_green"
                  >
                    {{ propQuestionBankObj?.user_response }}
                  </span>
                  <span
                    v-else
                    :class="queData?.answer_score !== 0 ? 'pill_badge_box bg_green' : 'pill_badge_box bg_red'"
                  >
                   {{ propQuestionBankObj?.user_response?.includes("#")
                        ? "#"
                        : propQuestionBankObj?.user_response
                    }}
                  </span>
                </h5>
              </div>
              <small v-if="queData?.answer_score !== 0 && userData.user_role == 'USERROLE11118' ">
                Answer corrected by Trainer
              </small>
              <QuestionScoringModal
                :propQueData="queData"
                :propQuestionBankObj="propQuestionBankObj"
                :propMaxScore="queData.question_points"
                @emitScoreSubmitted="onScoreSubmitted"
              />
              <div v-if="queData?.answer_score !== null && queData?.answer_score !== undefined" class="alert alert-primary mt-3">
                <strong>Score:</strong>
                <span class="ml-2">
                  {{getAnsScore(queData)}} / {{ queData?.question_points }} points
                </span>
              </div>
            </template>
            <template v-else>
              <div class="questionFooter mt-3">
                <h5> NOTE : <span class="primary-color" style="text-transform: capitalize;">This is a non MCQ type question. Hence no choices were provided</span></h5>
                <div style="gap: 8px;" class="d-flex align-items-center mt-2" v-if ="queData.answer_image">
                  <h5>Attached Answer Image: </h5>
                  <img
                    v-if="queData.answer_image"
                    :src="pdfLogo"
                    class="me-2 pointer"
                    @click="openFile(queData.answer_image)"
                    style="height: 24px;"
                  />
                </div>
                <h5 v-if="queData.answer" class="mt-3">Your Answer :
                  <span v-if="queData.answer === 'z'" style="color: orange">
                    Unattempted
                  </span>
                  <span v-else class="primary-color">
                    {{ queData.answer }}
                  </span>
                </h5>
                <QuestionScoringModal
                  :propQueData="queData"
                  :propQuestionBankObj="propQuestionBankObj"
                  :propMaxScore="queData.question_points"
                  @emitScoreSubmitted="onScoreSubmitted"
                />
                <div v-if="queData.answer_score !== null && queData.answer_score !== undefined" class="alert alert-primary mt-3">
                  <strong>Score:</strong>
                  <span class="ml-2">
                    {{ queData.answer_score }} / {{ queData.question_points }} points
                  </span>
                </div>
              </div>
            </template>
          </div>
        </div>
        <!--/questionContainer-->

      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 questionBox mt-2">
        <div class="questionContainer">
          <!-- quizOptions -->
          <div class="optionContainer mt-2" :key="update">
            <template v-if="queData.is_mcq == 1">
              <!-- Answer Explanation -->
              <div class="questionFooter">
                <h5>Explanation:
                  <span v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" @click="solveQuizBankViaGPT" class="pull-right" title="Solve Question via AI">
                    <i class="fa fa-quora font-size-20 primary-color pointer" aria-hidden="true"></i>
                  </span>
                </h5>
                <span class="katex" v-html="queData.answer_explanation"></span>
              </div><!-- Answer Explanation -->
            </template>
            <template v-else>
              <div class="questionFooter mt-3">
                <h5>Explanation:
                  <button v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" @click="solveQuizBankViaGPT" class="" title="Solve Question via AI">
                    <i class="fa fa-quora font-size-20 primary-color pointer" aria-hidden="true"></i>
                  </button>
                </h5>
                <span class="katex" v-html="queData.answer_explanation"></span>
              </div><!-- Answer Explanation -->
            </template>
          </div>
        </div>
        <!--/questionContainer-->

      </div>
    </div>

    <b-modal id="DemosCal" style="width:100%" v-model="showCalculatorModal" @shown="makeDraggable" size="lg">
      <template #modal-header="">
        <h4 class=" mb-1 instituteTitle_block">
          Desmos Calculator <i class="fa-solid fa-arrows-up-down-left-right pointer pull-right m-2" title="Drag calculator"  aria-hidden="true"></i>
        </h4>
      </template>
      <iframe style="height: 70vh; width: 100%;" :src="desmosCalc" />
    </b-modal>

    <b-modal
      v-model="showModelImageView"
      name="Modal"
      scrollable
      size="xl"
      >
      <image-view :propImageUrl="propImageUrl" :propImg="propImg"/>
    </b-modal>

    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle"
    >
      <div v-html="toastMsg"></div>
    </b-toast>
  </div>
</template>

<script>
import { socialvue } from "../../../config/pluginInit"
import { QuizBanks } from "../../../FackApi/api/quizBank.js"
import pdfLogo from "../../../assets_gide/img/logo/pdfLogo.png"
import { QuizAnswers } from "../../../FackApi/api/quizAnswers.js"
import ImageView from "./ImageView.vue"
import { base64decode } from "nodejs-base64"
import "katex/dist/katex.min.css"
import katex from "katex"
import QuestionScoringModal from "./QuestionScoringModal.vue"

export default {
  name: "QuestionQuiz",
  components: {
    ImageView,
    QuestionScoringModal
  },
  data () {
    return {
      apiName: "quiz_bank_view",
      questionIndex: 0,
      queData: {},
      userResponses: {},
      quizStarted: true,
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Quiz Response",
      update: 0,
      qbk_id: null,
      showCalculatorModal: false,
      desmosCalc: "https://www.desmos.com/calculator?lang=en",
      propImageUrl: null,
      propImg: null,
      showModelImageView: false,
      pdfLogo: pdfLogo
    }
  },
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propQuestionBankObj: {
      type: Object,
      default: null
    },
    propQuestionState: {
      type: Number,
      default: 0
    }
  },
  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    }
  },
  mounted () {
    socialvue.index()
    window.katex = katex

    if (this.$route.params.qbk_id) {
      this.qbk_id = this.$route.params.qbk_id
    }
    if (this.propQuestionBankObj && this.propQuestionBankObj.qbk_id) {
      this.qbk_id = this.propQuestionBankObj.qbk_id
    }
    this.quizBankView()
  },
  methods: {
    /**
     * getAnsScore
     */
    getAnsScore (queData) {
      // Use the saved grade (admin manual grading) when available
      if (queData?.answer_result !== undefined && queData?.answer_result !== null) {
        return Number(queData.answer_result) === 1 ? (queData?.answer_score || queData?.question_points) : 0
      }
      if (this.propQuestionBankObj?.user_response?.trim().toLowerCase() === queData.correct_answers?.trim().toLowerCase()) {
        return queData?.answer_score || queData?.question_points
      }
      return 0
    },
    /**
     * onScoreSubmitted
     */
    onScoreSubmitted (scoreResult) {
      if (scoreResult.success) {
        this.toastTitle = scoreResult.title
        this.toastMsg = scoreResult.message
        this.toastVariant = "success"
        this.showToast = true

        // Update queData with answer_score and answer_result
        if (scoreResult && scoreResult.data && scoreResult.data.answer_score !== undefined && scoreResult.data.answer_result !== undefined) {
          this.queData.answer_score = scoreResult.data.answer_score
          this.queData.answer_result = scoreResult.data.answer_result
        }
        this.$emit("emitCloseQuestionQuizViewModal", true) // true => refresh scores but keep the modal open
        this.showModal = false
      }
      else {
        this.toastTitle = "Unattempted"
        this.toastMsg = scoreResult.message
        this.toastVariant = "warning"
        this.showToast = true
      }
    },
    /**
     * quizBankView
     */
    async quizBankView () {
      try {
        let quizBankViewResp = await QuizBanks.quizBankView(this, this.qbk_id, this.propQuestionBankObj.aprs_id ? this.propQuestionBankObj.aprs_id : null, this.propQuestionState)
        if (quizBankViewResp && quizBankViewResp.resp_status) {
          this.queData = quizBankViewResp.resp_data.data

          // Quiz Images
          if (this.queData.image) {
            this.vmCoverPic = this.queData.image
          }

          if (this.queData.answer_explanation) {
            var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/
            this.queData.answer_explanation = base64regex.test(this.queData.answer_explanation) ? base64decode(this.queData.answer_explanation) : this.queData.answer_explanation
            /*
             * For Future Use to detect LaTex Script. ~ => Space, //=> Newline.
             * Currently can't enter multiple new lines as Katex does not recognise it
             * IS_LATEX_RESPONSE needs to be added in the GPT Response
             */
            let answerExplanationLatex = ""
            if (this.queData.answer_explanation.includes("IS_LATEX_RESPONSE")) {
              this.queData.answer_explanation = this.queData.answer_explanation.replace("IS_LATEX_RESPONSE", "")
              answerExplanationLatex = this.queData.answer_explanation.replace(/ /g, "~").replace(/\\\[/g, "").replace(/\\\]/g, "").replace(/\\\(/g, "").replace(/\\\)/g, "").replace(/\n/g, "\\")
              answerExplanationLatex = katex.renderToString(answerExplanationLatex, { throwOnError: false })
              this.queData.answer_explanation = answerExplanationLatex
            }

            this.queData.answer_explanation = this.queData.answer_explanation.replace("IS_LATEX_RESPONSE", "")
            if (!this.queData.answer_explanation.includes("<svg") && !this.queData.answer_explanation.includes("ql-formula")) {
              this.queData.answer_explanation = this.queData.answer_explanation.replace(/\n/g, "<br/>")
            }
          }

          this.queData.qbk_category_option = this.queData.qbk_category
        }
      }
      catch (err) {
        console.error("Exception occurred at quizBankView() and Exception:", err.message)
      }
    },
    /**
     * imgModal
     */
    imgModal (quesObj) {
      try {
        this.propImageUrl = quesObj
        this.showModelImageView = true
      }
      catch (err) {
        console.error("Exception occurred at ImageView() and Exception:", err.message)
      }
    },
    /**
     * solveQuizBankViaGPT
     */
    async solveQuizBankViaGPT (questionData) {
      try {
        const solveObj = {
          qbk_id: this.queData.qbk_id,
          question: this.queData.question,
          answer_choices: JSON.stringify(this.queData.answer_choices),
          image: this.queData.image
        }
        let quizSolveResp = await QuizBanks.quizBankSolve(this, solveObj)
        if (!quizSolveResp.resp_status) {
          this.toastMsg = quizSolveResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
          return
        }

        this.toastMsg = quizSolveResp.resp_msg
        this.toastVariant = "success"
        this.showToast = true
      }
      catch (err) {
        console.error("Exception in solveQuizBankViaGPT and err: ", err)
      }
    },
    /**
     * quizBankEdit
     */
    quizBankEdit (qbkId) {
      window.open("/quizBank_edit/" + qbkId, "_blank")
    },
    /**
     * makeDraggable
     */
    makeDraggable () {
      this.$nextTick(() => {
        const modal = document.querySelector("#DemosCal .modal-dialog")
        const header = modal.querySelector(".modal-header")

        let isDragging = false
        let offsetX = 0
        let offsetY = 0

        header.style.cursor = "move"

        // --- Desktop events (mouse) ---
        header.onmousedown = (e) => {
          e.preventDefault()
          startDragging(e.clientX, e.clientY)
        }

        // --- Mobile events (touch) ---
        header.addEventListener("touchstart", (e) => {
          const touch = e.touches[0]
          startDragging(touch.clientX, touch.clientY)
        }, { passive: false })

        function startDragging (x, y) {
          isDragging = true
          offsetX = x - modal.offsetLeft
          offsetY = y - modal.offsetTop

          document.onmousemove = (e) => {
            if (isDragging) {
              moveModal(e.clientX, e.clientY)
            }
          }

          document.addEventListener("touchmove", (e) => {
            if (isDragging) {
              e.preventDefault()
              const touch = e.touches[0]
              moveModal(touch.clientX, touch.clientY)
            }
          }, { passive: false })

          document.onmouseup = stopDragging
          document.addEventListener("touchend", stopDragging, { passive: false })
        }

        function moveModal (x, y) {
          modal.style.position = "absolute"
          modal.style.margin = 0
          modal.style.left = x - offsetX + "px"
          modal.style.top = y - offsetY + "px"
          modal.style.width = "100%"
        }

        function stopDragging () {
          isDragging = false
          document.onmousemove = null
          document.onmouseup = null
          document.ontouchmove = null
          document.ontouchend = null
        }
      })
    },
    /**
     * openFile
     */
    openFile (url) {
      if (url === "") {
        // empty url means that univ admin has not accepted the application
        this.showToast = true
        this.toastVariant = "danger"
        this.toastMsg = "This document can only be viewed after accepting the application"
        return
      }
      window.open(url, "_blank")
    },
    /**
     * quizAnswersUpdate
     */
    async quizAnswersupdate (isCorrect, queData) {
      try {
        const payload = {
          user_id: queData.user_id,
          aprs_id: this.propQuestionBankObj.aprs_id ? this.propQuestionBankObj.aprs_id : null,
          qbk_id: queData.qbk_id,
          answer_result: isCorrect,
          app_id: queData.app_id
        }

        const response = await QuizAnswers.quizAnswersupdate(this, payload)
        if (response && response.resp_status) {
          this.toastMsg = "Response updated successfully"
          this.toastVariant = "success"
          this.showToast = true
        }
      }
      catch (error) {
        console.error("Error updating response:", error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Montserrat:400,400i,700");
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,400i,700");

body {
  font-family: "Open Sans", sans-serif;
  font-size: 18px;
  /* mocking native UI */
  cursor: default !important; /* remove text selection cursor */
  user-select: none; /* remove text selection */
  user-drag: none; /* disbale element dragging */
}
.title, .subtitle {
  font-family: "Poppins", sans-serif;
  font-weight: normal;
}
.title {
  font-size: 18px !important;
  margin-top: 5px !important;
}
.animated {
  transition-duration: 0.3;
}
.que {
  border-bottom: 1px solid #f1f1f1;
  margin-bottom: 10px;
  padding-top: 10px;
}
.questionBox {
  padding-top: 0px;
  padding-bottom: 10px;
  .quizForm {
    display: block;
    white-space: normal;
    .quizFormContainer {
      height: 100%;
      margin: 15px 18px;
      padding: 10px;
      .field-label {
        text-align: left;
        margin-bottom: 0.5rem;
      }
    }
  }
  .quizCompleted {
    width: 100%;
    padding: 25px;
  }
  .questionContainer {
    white-space: normal;
    height: 100%;
    width: 100%;
  .optionContainer {
      margin-top: 0px;
      flex-grow: 1;
      .option {
        border-radius: 5px;
        margin-bottom: 15px;
        padding: 3px 0px 0px 50px;
        cursor: pointer;
        border: 1px solid #f1f1f1;
        overflow: hidden;
        font-size: 14px;
        min-height: 35PX;
        font-weight: 500;
        position: relative;
        &.is-selected {
          border-color: var(--iq-primary);
          background-color: white;
        }
        &:hover {
          background-color: rgba(0, 0, 0, 0.1);
        }
      }
    }
    .questionFooter {
      width: 100%;
      align-self: flex-end;
      h5{
        font-size: 14px;
        color: #000;
      }
      .pagination {
        //padding: 10px 15px;
        margin: 15px 25px;
      }
      .progressContainer {
        // margin: 15px 25px;
      }
    }
  }
}
h3.tag{
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 5px;
  .duration{
    float: right;
    font-size:18px;
  }
}
.tags h3{
  font-size:18px;
  font-weight: 500;
}
.progress{
  height: 0.5rem;
}
@media screen and (min-width: 769px) {
  .container {
    height: 100%;
    .columns {
      height: 100%;
      .column {
        height: 100%;
      }
    }
  }
  .questionBox {
    align-items: center;
    justify-content: center;
    padding: 20px;
    .questionContainer {
      display: flex;
      flex-direction: column;
    }
  }
  .que {
    // box-shadow: inset rgb(255 255 255) -20px 0px 20px 0px;
    margin-bottom: 0px;
  }
}
@media screen and (max-width: 768px) {
  .questionFooter{
    button{
      margin: auto;
      margin-bottom:5px;
    }
  }
}
.next{
  float:right;
}
::-webkit-progress-bar {
  background-color: #f1f1f1;
}
.optionNo {
  background-color: #e5252c;
  color: #fff;
  left: 0px;
  position: absolute;
  width: 40px;
  height: 33px;
  top: 0px;
}
.optionNo span {
 position: absolute;
  right: -9px;
  left: auto;
  top: 0;
  bottom: 0px;
  margin: auto;
  height: 0px;
  font-weight: 600;
  line-height: 0;
  font-size: 14px;
  text-align: center;
  width: 100%;
}
.questionTag {
  font-size: 14px;
  word-break: normal;
  text-transform: none;
  font-weight: 500;
  line-height: 25px;
  img{
    max-height: 250px;
  }
}
.que_img{
  height: auto;
  width: 200px;
  display: block;
}
.magnifying_glass{
  padding-top: 10px;
}
.clock_boxs{
  border: 2px solid;
  border-color: #dcdcdc;
  border-radius: 5px;
  padding: 8px 11px;
  color: #e5252c;
  font-size: 16px;
}
.clock_box1{
  padding-left:5px;
  min-width: 35px;
  display: inline-flex;
  text-align: center;
}
.clock_box2{
  padding-left:10px;
  min-width: 35px;
  display: inline-flex;
  text-align: center;
}
.counts{
  position: relative;
  top: -7px;
  select{
    border: 2px solid #dcdcdc !important;
  }
  .form-control{
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    width: 80px;
  }
}
.instituteTitle_block{
  width: 100%;
}
.bg-gray{
  background-color: #e6e6e6;
}
.pill_badge_box {
  border-radius: 100% !important;
  color: #fff !important;
  display: inline-flex;
  justify-content: center;
  width: 26px;
  height: 26px;
  line-height: 23px;
}
.bg_green {
  background-color: rgba(0, 128, 0, 0.5) !important;
  border: 1px solid rgba(3, 68, 3, 0.5);
}
.bg_red {
  background-color: rgb(245, 53, 53);
  border: 1px solid rgb(204, 46, 46);
}
</style>
